import { ForgotPassword as ForgotPasswordComponent } from 'features/ForgotPassword';

const ForgotPassword = (): JSX.Element => {
	return <ForgotPasswordComponent />;
};
export default ForgotPassword;
